/** Client-side "as you type" formatting only — purely a UX convenience. The server
 * re-normalizes and re-validates independently and is the actual source of truth. */
function formatAsYouType(digits: string): string {
  const d = digits.slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function PhoneInput({
  value,
  onChange,
  id,
  placeholder,
  autoFocus,
}: {
  value: string;
  onChange: (value: string) => void;
  id: string;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  return (
    <input
      id={id}
      className="input"
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder}
      value={value}
      autoFocus={autoFocus}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '');
        onChange(formatAsYouType(digits));
      }}
    />
  );
}
